"use client"

import { useEffect, useState } from "react"
import { useRouter } from "next/navigation"
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "../ui/alert-dialog"

export function DevToolsDetector() {
    const router = useRouter()
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        // Production only check
        if (process.env.NODE_ENV !== "production") return

        let devtoolsOpen = false
        const threshold = 160

        const checkDevTools = () => {
            // Bypass if the AskFinz Extension or Desktop app is active — their
            // side panel / window chrome legitimately shrinks innerWidth, which
            // is indistinguishable from side-docked devtools by this heuristic.
            if ((window as any).__ASKFINZ_EXTENSION_ACTIVE__ || (window as any).__ASKFINZ_DESKTOP__) {
                return
            }
            // Bypass if running inside the askFinz Electron browser app
            // The Electron window chrome causes outerWidth-innerWidth to exceed the threshold naturally
            if (window.location.search.includes('app_version=') || navigator.userAgent.includes('Electron')) {
                return
            }

            const widthThreshold = window.outerWidth - window.innerWidth > threshold
            const heightThreshold = window.outerHeight - window.innerHeight > threshold

            if (widthThreshold || heightThreshold) {
                if (!devtoolsOpen) {
                    devtoolsOpen = true
                    setIsOpen(true)

                    // Redirect after a short delay
                    setTimeout(() => {
                        window.location.href = "https://askfinz.ai/dev-tools"
                    }, 3000)
                }
            } else {
                devtoolsOpen = false
            }
        }

        // Check every 1 second
        const intervalId = setInterval(checkDevTools, 1000)

        // Also check on resize
        window.addEventListener("resize", checkDevTools)

        // Disable right-click context menu as a deterrent
        const handleContextMenu = (e: MouseEvent) => {
            e.preventDefault()
        }
        window.addEventListener("contextmenu", handleContextMenu)

        // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
        const handleKeyDown = (e: KeyboardEvent) => {
            if (
                e.key === "F12" ||
                (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J")) ||
                (e.ctrlKey && e.key === "U")
            ) {
                e.preventDefault()
            }
        }
        window.addEventListener("keydown", handleKeyDown)

        return () => {
            clearInterval(intervalId)
            window.removeEventListener("resize", checkDevTools)
            window.removeEventListener("contextmenu", handleContextMenu)
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [router])

    return (
        <AlertDialog open={isOpen}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Developer Tools Detected</AlertDialogTitle>
                    <AlertDialogDescription>
                        Accessing Developer Tools is restricted on this platform. You will be redirected shortly.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogAction onClick={() => window.location.href = "https://askfinz.ai/dev-tools"}>
                        Proceed
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}
